import React from 'react'
import Wrapper from './Wrapper'
import MessageUs from 'screens/Metabar/Support/MessageUs'
import wentWrong from 'assets/images/went-wrong.svg'

export default function UnknownError({ title = 'Something went wrong' }) {
  const image = <img src={wentWrong} alt="went-wrong" style={{ width: 564 }} />
  return (
    <Wrapper title={title} image={image}>
      <div>
        <MessageUs /> if you need any further help
      </div>
    </Wrapper>
  )
}
